import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import authService from '../services/auth.service';
import './Sidebar.css';

export default function Sidebar() {
  const [adminName, setAdminName] = React.useState('Admin');
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    try {
      const user = authService.getCurrentUser();
      if (user && (user.name || user.email)) {
        setAdminName(user.name || user.email);
        return;
      }
      const token = authService.getIdToken();
      if (token) {
        const parts = token.split('.');
        if (parts.length >= 2) {
          const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
          setAdminName(payload.name || payload.email || 'Admin');
        }
      }
    } catch (e) {
      console.warn('Failed to load admin name:', e);
    }
  }, []);

  const NavItem = ({ to, label, active, icon }) => (
    <li>
      <Link to={to} className={"nav-link" + (active ? ' active' : '')}>
        <span className="nav-icon" aria-hidden dangerouslySetInnerHTML={{ __html: icon }} />
        <span className="nav-label">{label}</span>
      </Link>
    </li>
  );

  const icons = {
    dashboard: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="8" height="8" rx="1" fill="#6C8EF5"/><rect x="13" y="3" width="8" height="5" rx="1" fill="#8FB4FF"/><rect x="13" y="10" width="8" height="11" rx="1" fill="#CFE0FF"/><rect x="3" y="13" width="8" height="8" rx="1" fill="#4E6BE6"/></svg>',
    users: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z" fill="#6C8EF5"/><path d="M4 20c0-2.21 3.58-4 8-4s8 1.79 8 4v1H4v-1z" fill="#8FB4FF"/></svg>',
    import: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 3v10" stroke="#6C8EF5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 10l7-7 7 7" stroke="#6C8EF5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><rect x="4" y="14" width="16" height="6" rx="2" fill="#CFE0FF"/></svg>',
    verification: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="9" stroke="#6C8EF5" stroke-width="2"/><path d="M8 12l3 3 5-5" stroke="#6C8EF5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    enquiries: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" fill="#CFE0FF" stroke="#6C8EF5" stroke-width="1.5"/><line x1="8" y1="9" x2="16" y2="9" stroke="#6C8EF5" stroke-width="1.5" stroke-linecap="round"/><line x1="8" y1="13" x2="13" y2="13" stroke="#8FB4FF" stroke-width="1.5" stroke-linecap="round"/></svg>',
    settings: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 15.5A3.5 3.5 0 1 0 12 8.5a3.5 3.5 0 0 0 0 7z" fill="#6C8EF5"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06c.39-.39.5-.95.33-1.44A1.65 1.65 0 0 0 4 15.5H3a2 2 0 0 1 0-4h.09c.16-.5.06-1.05-.33-1.44l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06c.39.39.95.5 1.44.33.5-.16 1.05-.06 1.44.33.24.24.61.36.97.36H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09c.16.5.06 1.05-.33 1.44-.39.39-.5.95-.33 1.44.17.49.56 1.05 1.07 1.36.39.24.93.12 1.24-.19l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06c-.39.39-.5.95-.33 1.44.16.5.06 1.05-.33 1.44z" fill="#8FB4FF"/></svg>',
    logout: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 17l5-5-5-5" stroke="#FF6B6B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 12H9" stroke="#FF6B6B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 19H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h7" stroke="#FF6B6B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  return (
    <div className="admin-sidebar">
      <div className="side_header">
        <img src="/assets/images/avatar-placeholder.svg" alt="" />
        <div>
          <div style={{ fontWeight: 700 }}>{adminName}</div>
          <div style={{ fontSize: 12, color: '#777' }}>Administrator</div>
        </div>
      </div>
      <ul>
        <NavItem to="/admin/dashboard" label="Dashboard" active={location.pathname === '/admin/dashboard'} icon={icons.dashboard} />
        <NavItem to="/admin/import" label="Import Data" active={location.pathname === '/admin/import'} icon={icons.import} />
        <NavItem to="/admin/unverified-users" label="Manage Users" active={location.pathname === '/admin/unverified-users'} icon={icons.verification} />
        <NavItem to="/admin/enquiries" label="Enquiries" active={location.pathname === '/admin/enquiries'} icon={icons.enquiries} />
        <NavItem to="/admin/settings" label="Settings" active={location.pathname === '/admin/settings'} icon={icons.settings} />
      </ul>
      <div style={{ padding: 12 }}>
        <button className="sidebar-logout" onClick={() => { authService.logout(); navigate('/'); }}>
          <span style={{ marginRight: 8 }} dangerouslySetInnerHTML={{ __html: icons.logout }}></span>
          Logout
        </button>
      </div>
    </div>
  );
}
